import React, { useCallback } from 'react';

import FieldType from 'types/FieldType';
import SplitButton from './SplitButton';

const options = [
  { value: FieldType.SINGLE_SELECT, label: 'Add Single Select Field' },
  { value: FieldType.MULTI_SELECT, label: 'Add Multi Select Field' },
  { value: FieldType.TEXT, label: 'Add Text Field' },
  { value: FieldType.TEXT_AREA, label: 'Add Text Area Field' },
  { value: FieldType.NUMERIC, label: 'Add Numeric Field' },
];

interface AddFieldButtonProps {
  onClick: (value: FieldType) => void;
}

const AddFieldButton: React.FC<AddFieldButtonProps> = ({ onClick }) => {
  const handleOnClick = useCallback(
    (key: string | null) => {
      onClick(key as FieldType);
    },
    [onClick],
  );

  return <SplitButton options={options} onClick={handleOnClick} />;
};

export default AddFieldButton;
